import React from "react";
import { Button, Card, Col, Icon, Row, Spin, Table, message  } from "antd";
import { connect } from "react-redux";

import TagProductModal from "./tag-product-modal";

import { 
    _getPingRfidServer, 
    _getReadTagsFromRfidServer, 
    _postWriteTagsToRfidServer, 
    _postGetTagsFromEezeeServer
} from "../../services";

class RfidProductTagger extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            pendingRfidOperation: false,
            foundRfidWriter: 0,
            tagsFound: [],
            tagProductMode: false,
            selectedRfidTags: []
        }
    }

    componentDidMount(){

        // check if rfid server exist
        _getPingRfidServer()
            .then( res => {

                if( res.data === "pong" ){
                    this.setState({ 
                        foundRfidWriter: 2
                    })
                }

            })
            .catch( e => {
                this.setState({ foundRfidWriter: 1 });
            })
    }

    render(){

        return (
            <Spin spinning={this.state.pendingRfidOperation}>
                <Card>
                    <Row type="flex" gutter={16} align={"middle"}>
                        <Col>
                            <h3>Rfid Product Tagger</h3>
                        </Col>
                        {this.renderRfidServerStatus()}
                    </Row>

                    <div style={{ minHeight: 400 }}>                
                        {this.renderRfidReaderControls()}

                        {this.renderRfidTagsFound()}
                    </div>

                    {this.renderTagProductModal()}
        
                </Card>
            </Spin>
        );
        
    }

    renderRfidReaderControls = () => {

        let controlsDisabled = this.state.foundRfidWriter !== 2;
        let tagProductsDisabled = this.state.selectedRfidTags.length === 0;

        return (
            <Row style={{ marginTop: 8 }} type={"flex"} gutter={8}>
                <Col>
                    <Button 
                        onClick={ () => this._readTagsAndSetState( 10 ) }
                        disabled={controlsDisabled}>
                        Read (10 secs)
                    </Button>
                </Col>
                <Col>
                    <Button 
                        onClick={ () => this._readTagsAndSetState( 2 ) }
                        disabled={controlsDisabled}>
                        Quick Read (2 secs)
                    </Button>
                </Col>
                <Col>
                    <Button 
                        onClick={ () => this.setTagProductMode( true ) }
                        disabled={controlsDisabled || tagProductsDisabled}>
                        Tag Products
                    </Button>
                </Col>

            </Row>
        )

    }

    renderRfidServerStatus = () => {

        let rfidStatus;
        let iconSize = 18;

        switch( this.state.foundRfidWriter ){
            case 0:
                rfidStatus = (
                    <Spin indicator={
                        <Icon type="loading" style={{ fontSize: iconSize }} spin />
                    } />
                );     
                break;

            case 1:
                rfidStatus = (
                    <Icon 
                        type="close-circle" 
                        style={{ fontSize: iconSize, color: "#f5222d" }} />
                )
                break;

            case 2:
                rfidStatus = (
                    <Icon
                        type="check-circle"
                        style={{ fontSize: iconSize, color: "#52c41a" }}
                        />
                )
                break;
        }

        return (
            <Col>
                {rfidStatus}
            </Col>
        )
    }

    renderRfidTagsFound = () => {

        const columns = [
            {
                title: "#",
                key: "id",
                render: ( _record, _text, i ) => i + 1
            },
            {
                title: "Tag ID",
                dataIndex: "tagId",
                key: "tagId"
            },
            {
                title: "Product Title",
                dataIndex: "productTitle",
                key: "productTitle"
            },
            {
                title: "Found Count",
                dataIndex: "foundCount",
                key: "foundCount"
            },

            {
                title: "Retag Success",
                dataIndex: "retagSuccess",
                key: "retagSuccess",
                render: ( retagSuccess ) => {
                    
                    if( retagSuccess ){
                        return <Icon type="check-circle" />
                    }

                    return "";


                }
            },
            {
                title: "voided",
                dataIndex: "voided",
                key: "voided",
                render: ( voided ) => {

                    if( voided ){
                        return "VOIDED";
                    }

                    return "";

                }
            }

        ];

        // set rules for tags that can't be selected
        let selectedRowKeys = this.state.selectedRfidTags
            .filter( selectedRfidTag => {

                // if developers, give them the ability to retag stuff
                if( this.props.user.permissions.ezTech ){
                    return true;
                }
                
                return (
                    selectedRfidTag.foundCount >= 40 && 
                    !selectedRfidTag.voided && 
                    !selectedRfidTag.retagSuccess
                );

            })
            .map( selectedRfidTag => selectedRfidTag.tagId );

        return (

            <Table
                
                rowKey={"tagId"}
                rowSelection={{
                    selectedRowKeys,
                    onChange: ( _rowKey, selectedRows ) => {

                        this.setState({
                            selectedRfidTags: selectedRows
                        });
                
                    },
                    getCheckboxProps: record => {

                        // if developers, give them the ability to retag stuff
                        if( this.props.user.permissions.ezTech ){
                            return {
                                disabled: false
                            }
                        }

                        return {
                            disabled: record.foundCount < 40 || record.voided || record.retagSuccess
                        }
                    }
                }}
                size={"small"}
                pagination={false}
                style={{ marginTop: 8 }}
                columns={columns}
                dataSource={ this.state.tagsFound }
                />
        )
    }

    renderTagProductModal = () => {
        
        if( !this.state.tagProductMode || this.state.selectedRfidTags.length === 0 ){
            return null;
        }

        return (
            <TagProductModal 
                onCancel={() => this.setTagProductMode(false)}
                selectedRfidTags={this.state.selectedRfidTags}
                />
        )

    }

    setTagProductMode = ( tagProductMode ) => {

        if( !tagProductMode ){
            this._readTagsAndSetState( 2 );
        }

        this.setState({
            tagProductMode
        })

    }

    _readTagsAndSetState = ( scanTime = 10 ) => {

        message.destroy();

        message.loading("Reading tags from RFID reader", 0);

        this.setState({
            pendingRfidOperation: true
        });

        _getReadTagsFromRfidServer( scanTime )
            .then( rfidServerResponse => {

                message.destroy();

                message.success("Reading tags from RFID reader");

                let tallyTags = message.loading("Tallying tags found with eezee", 0 );

                let tagIdsFound = Object.keys( rfidServerResponse.data );

                return _postGetTagsFromEezeeServer( tagIdsFound )
                    .then( res => {

                        // message.destroy();

                        setTimeout( () => {

                            tallyTags();

                            message.success("Tallying tags found with eezee");
    
                            // message.success("Read Tags Done!", 1000);
    
                            let liveTagMap = res.data.rfidTags.reduce( (acc, cur) => {
    
                                acc[ cur.tagNumber ] = cur;
    
                                return acc;
    
                            }, {});
    
                            let tagsFound = tagIdsFound.map( tagId => {
    
                                let productTitle = liveTagMap[tagId] && liveTagMap[tagId].productTitle || "",
                                    retagSuccess = liveTagMap[tagId] && liveTagMap[tagId].retagSuccess || false,
                                    voided = liveTagMap[tagId] && liveTagMap[tagId].voided,
                                    foundCount = rfidServerResponse.data[tagId];
    
                                return {
                                    tagId,
                                    foundCount,
                                    productTitle,
                                    retagSuccess,
                                    voided
                                }
                            });
    
                            this.setState({
                                pendingRfidOperation: false,
                                tagsFound,
                                selectedRfidTags: []
                            });
    

                        }, 500);

                    })
        
                

            })
    }


}

export default connect( 
	state => ({
		user: state.user.data
	})
)(RfidProductTagger);


// WEBPACK FOOTER //
// ./src/components/rfid/product-tagger.js